/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React from "react";
import { Trans, useTranslation } from "next-i18next";
import cx from "classnames";

import BackButton from "../../BackButton";
import LogoutButton from "components/LogoutButton";
import { SettingsMenuItem } from "../SettingsMenuItem";
import {
  isSettingsSectionAvailable,
  SETTINGS_SECTIONS,
} from "../settingsSections";

import styles from "./SettingsMenu.module.scss";

export interface ISettingsMenuProps {
  submenuKey?: string;
  isViaPartner: boolean;
}

export const SettingsMenu = ({
  submenuKey,
  isViaPartner,
}: ISettingsMenuProps) => {
  const { t } = useTranslation("translations");

  const currentSection = SETTINGS_SECTIONS.find(
    (section) => section.key === submenuKey
  );

  return (
    <div className={styles.container}>
      {currentSection ? (
        <div className={styles.sectionTitleContainer}>
          <BackButton />
          <div className={styles.sectionTitle}>
            <Trans
              t={t}
              i18nKey={currentSection.titleKey}
              components={{ bold: <span className="bold" /> }}
            />
          </div>
        </div>
      ) : (
        <div className={styles.titleContainer}>
          <BackButton />
          <div className={styles.title}>{t("web_my_account_header")}</div>
        </div>
      )}
      <div
        className={cx({
          [styles.menuContainer]: !!submenuKey,
        })}
      >
        <ul className={styles.menu}>
          {SETTINGS_SECTIONS.filter((section) =>
            isSettingsSectionAvailable(section, isViaPartner)
          ).map((section) => (
            <SettingsMenuItem
              key={section.key}
              submenuKey={section.key}
              isActive={section === currentSection}
            >
              <Trans
                t={t}
                i18nKey={section.titleKey}
                components={{ bold: <span className="bold" /> }}
              />
            </SettingsMenuItem>
          ))}
        </ul>
        <LogoutButton variant="subtle" />
      </div>
    </div>
  );
};

export default SettingsMenu;
